class FilterToggler {

    constructor() {
        this.toggler = document.querySelector(".filter-toggler");
        this.filter = document.querySelector(".filter");
        this.init()
    }

    static existsOnPage() {
      return (document.querySelector(".filter-toggler") !== null);
    }
  
    init() {
      if (this.isTogglerVisible()) {
        this.hideFilter();  
      }

      this.toggler.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleFilterVisibility();
      })
    }

    isTogglerVisible() {
      return (window.getComputedStyle(this.toggler, null).display !== 'none');
    }

    toggleFilterVisibility() {
      if (this.filter.classList.contains('filter--visible')) {
        this.hideFilter();
      }
      else {
        this.showFilter();
      }
    }

    showFilter() {
      this.filter.classList.add('filter--visible');
      this.toggler.classList.add('filter-toggler--opened');
    }

    hideFilter() {
      this.filter.classList.remove('filter--visible');
      this.toggler.classList.remove('filter-toggler--opened');              
    }
}

export default FilterToggler;

